import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import { RouterPaths } from "@/constants/router";
import { MainLayout } from "@/layouts/MainLayout";
import { Loader } from "@/features/common/loader/ui";


const routes = createRoutesFromElements(
  <Route path={RouterPaths.INDEX} element={<MainLayout />} hydrateFallbackElement={<Loader fullscreen fit />} >
    <Route index lazy={() => import('@/pages/Tournaments')} />
    <Route path={RouterPaths.TOURNAMENT} lazy={() => import('@/pages/Tournament/ui')} />
    <Route path={RouterPaths.TEAMS} lazy={() => import('@/pages/Teams')} />
    <Route path={RouterPaths.TEAM} lazy={() => import('@/pages/Team/ui')} />
    <Route path={RouterPaths.TEAM_EDIT} lazy={() => import('@/pages/TeamEdit/ui')} />
    <Route path={RouterPaths.CONTENT_PAGE} lazy={() => import('@/pages/ContentPage/ui')} />

    <Route path="*" element={<Navigate to={RouterPaths.INDEX} />} />
  </Route>
)

export const router = createBrowserRouter(routes, {
  future: {
    v7_partialHydration: true,
  }
});
